{
  "name": "painel",
  "version": "1.28.1",
  "scripts": {
    "ng": "ng",
    "start": "ng serve --port=7200 --open --host 0.0.0.0 --disable-host-check ",
    "build": "ng build --configuration=production --aot=true --optimization=true",
    "build:stag": "ng build --configuration=stag --aot=true --optimization=true",
    "watch": "ng build --watch --configuration development",
    "test": "ng test",
    "sonar": "sonar-scanner",
    "sentry:sourcemaps": "sentry-cli sourcemaps inject --org mar-saude --project patient ./dist/patient && sentry-cli sourcemaps upload --org mar-saude --project patient ./dist/patient",
    "changelog-version": "node generate-changelog-update-version.js",
    "commit-version": "git add . && git commit -m'Version name: '$(grep -m1 version package.json | awk -F: '{ print $2 }' | sed 's/[\", ]//g')''",
    "update-angular": "ng update @angular/core @angular/cli @angular/cdk @angular-devkit/build-angular @angular/compiler-cli @angular/material",
    "release": "npm run changelog-version && npm run commit-version && git push && git checkout main && git pull && git merge --no-ff --no-edit dev && git push && git checkout -"
  },
  "browser": {
    "fs": false,
    "path": false,
    "os": false
  },
  "private": true,
  "dependencies": {
    "@ag-grid-community/locale": "^33.2.3",
    "@amplitude/analytics-browser": "^2.34.0",
    "@angular/animations": "^19.2.18",
    "@angular/cdk": "^19.2.18",
    "@angular/common": "^19.2.18",
    "@angular/compiler": "^19.2.18",
    "@angular/core": "^19.2.18",
    "@angular/forms": "^19.2.18",
    "@angular/material": "^19.2.18",
    "@angular/material-moment-adapter": "^19.2.18",
    "@angular/platform-browser": "^19.2.18",
    "@angular/platform-browser-dynamic": "^19.2.18",
    "@angular/router": "^19.2.18",
    "@ngx-formly/core": "^6.3.12",
    "@ngx-formly/material": "^6.3.12",
    "@sentry/angular": "^9.19.0",
    "@sentry/cli": "^2.45.0",
    "@swimlane/ngx-charts": "^22.0.0-alpha.0",
    "ag-grid-angular": "^33.2.1",
    "ag-grid-community": "^33.2.1",
    "canvg": "^4.0.3",
    "chart.js": "^4.5.0",
    "chartjs-plugin-annotation": "^3.1.0",
    "chartjs-plugin-datalabels": "^2.2.0",
    "core-js": "^3.40.0",
    "d3": "^7.9.0",
    "dayjs": "^1.11.13",
    "flatpickr": "^4.6.13",
    "html2canvas": "^1.4.1",
    "html2pdf.js": "^0.14.0",
    "iframe-resizer": "^4.3.11",
    "jspdf": "^4.1.0",
    "lodash": "^4.17.23",
    "material-symbols": "^0.36.2",
    "ng2-charts": "^8.0.0",
    "ng2-currency-mask": "^13.0.3",
    "ngx-file-drop": "^16.0.0",
    "ngx-mask": "^17.0.7",
    "numeral": "^2.0.6",
    "rxjs": "~7.8.0",
    "tslib": "^2.6.3",
    "zone.js": "~0.15.0",
    "zstd-codec": "^0.1.5"
  },
  "devDependencies": {
    "@angular-devkit/build-angular": "^19.2.18",
    "@angular/cli": "^19.2.18",
    "@angular/compiler-cli": "^19.2.18",
    "@types/jasmine": "~5.1.5",
    "@types/numeral": "^2.0.5",
    "jasmine-core": "~5.6.0",
    "karma": "~6.4.0",
    "karma-chrome-launcher": "~3.2.0",
    "karma-coverage": "~2.2.0",
    "karma-jasmine": "~5.1.0",
    "karma-jasmine-html-reporter": "~2.1.0",
    "semver": "^7.6.0",
    "sonar-scanner": "^3.1.0",
    "typescript": "~5.6.3"
  }
}